import React from 'react';

import { ProgressComponentProps } from './types';

import { Progress as StyledProgress } from './styled';

const CIRCLE_STROKE_WIDTH = 15;

const Progress: ProgressComponentProps = props => (
  <StyledProgress
    // eslint-disable-next-line react/prop-types
    strokeWidth={props.type === 'circle' ? CIRCLE_STROKE_WIDTH : undefined}
    {...props}
  />
);

Progress.defaultProps = {
  trailColor: '#EAEDF5',
};

export default Progress;
